export default {
  get_started: {
    enter_your_information: {
      title: 'Enter your information',
      sub_title: "You'll have access to your demo anytime.",
      default_organization_name: 'My organization',
    },
    market_segment: {
      title: 'What type corresponds the most to your organization?',
    },
    field_of_interest: {
      title: 'Enter a word about your field of interest',
      sub_title: 'Our AI bot 🤖 will make your demo look real!',
      placeholder: 'Ex. Conference on microbiology',
    },
    check_inbox: {
      title: 'Check your inbox',
      sub_title: 'Click the magic link we just sent to {email} to access your event.',
      text: "Can't find it? Look in your spam folder.",
    },
    event_creation: {
      title: 'Event creation in progress',
      steps: [
        'Generating website content',
        'Putting together forms',
        'Generating registrations',
        'Generating submissions',
        'Finalizing the schedule',
        'Applying optimal settings',
        'Sprinkling a little magic here and there',
      ],
    },
    success: {
      title: 'Event successfully created!',
      message: 'Sit tight while we redirect you to your event.',
    },
  },
};
